import React from 'react';

function RewritePlanIssueSuggestionsList({
  title,
  items,
  expandedState,
  onToggleExpanded,
}) {
  if (!Array.isArray(items) || !items.length) return null;

  return (
    <section className="rwp-section">
      <h3 className="rwp-section-title">{title}</h3>
      <div className="rwp-actions-list">
        {items.map((item) => {
          const isExpanded = !!expandedState[item.expandKey];
          const isApproved = item.status === 'approved';

          return (
            <div
              key={item.id}
              className={`rwp-action-card rwp-priority-${item.severity || 'medium'}`}
            >
              <div
                className="rwp-action-header"
                onClick={() => onToggleExpanded(item.expandKey)}
              >
                <span className={`rwp-priority-badge rwp-priority-${item.severity || 'medium'}`}>
                  {item.severityLabel || item.severity}
                </span>
                <span className="rwp-action-chapter">{item.chapterLabel}</span>
                <span className="rwp-action-title">{item.title}</span>
                {isApproved && (
                  <span className="rwp-state-badge rwp-state-badge--approved">Approved as issue</span>
                )}
                <span className="rwp-action-scope">{item.scopeLabel}</span>
                <span className="rwp-action-chevron">{isExpanded ? '▾' : '▸'}</span>
              </div>

              {isExpanded && (
                <div className="rwp-action-body">
                  {item.description && <div className="rwp-suggestion-description">{item.description}</div>}
                  {Array.isArray(item.detailLines) && item.detailLines.map((line, idx) => (
                    <div key={`${item.id}-detail-${idx}`} className="rwp-inline-help">{line}</div>
                  ))}
                  {item.suggestedFix && (
                    <div className="rwp-suggestion-fix">
                      <strong>Suggested fix:</strong> {item.suggestedFix}
                    </div>
                  )}
                  {isApproved && <div className="rwp-decision-success">Approved as issue.</div>}

                  <div className="rwp-decision-buttons">
                    {!isApproved && (
                      <button
                        type="button"
                        className="btn subtle rwp-decision-btn rwp-decision-btn--approve"
                        onClick={item.onApprove}
                        disabled={item.isBusy}
                      >
                        {item.isBusy ? 'Saving...' : (item.approveLabel || 'Approve Issue')}
                      </button>
                    )}
                    <button
                      type="button"
                      className="btn subtle rwp-decision-btn rwp-decision-btn--dismiss"
                      onClick={item.onDismiss}
                      disabled={item.isBusy}
                    >
                      {item.isBusy ? 'Saving...' : (item.dismissLabel || (isApproved ? 'Remove from List' : 'Dismiss'))}
                    </button>
                  </div>

                  {item.error && <div className="rwp-decision-error">{item.error}</div>}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}

export default RewritePlanIssueSuggestionsList;